import { GOLD_DEEP, HAIR, IVORY, Serif } from "./kit";

export const HOME_PARTNERS = [
  "BDC", "Venture University", "CVCA", "Equivesto", "McKercher LLP", "Plug and Play",
  "Whitecap Venture Partners", "Canadian Women in Venture Capital", "UTSC Sam Ibrahim Centre", "Globe Theatre", "Capital M Ventures",
];

export const PartnerWall = ({ names, testId = "partner-wall" }) => (
  <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4" style={{ borderTop: HAIR, borderLeft: HAIR }} data-testid={testId}>
    {names.map((n) => (
      <div key={n} className="group flex items-center justify-center text-center px-5 py-9 transition-colors duration-500 hover:bg-white/[0.02]" style={{ borderRight: HAIR, borderBottom: HAIR }}>
        <span className="transition-colors duration-500 group-hover:text-white" style={{ ...Serif, color: IVORY, opacity: 0.82, fontSize: "clamp(1rem, 1.5vw, 1.2rem)", letterSpacing: "-0.005em" }}>{n}</span>
      </div>
    ))}
  </div>
);

export const PartnerGroups = ({ groups }) => (
  <div className="mt-14" data-testid="partner-groups">
    {groups.map(([group, names], i) => (
      <div key={group} className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-3 md:gap-12 py-7" style={{ borderTop: i === 0 ? HAIR : "none", borderBottom: HAIR }}>
        <p className="text-[10.5px] tracking-[0.3em] uppercase self-center" style={{ color: GOLD_DEEP }}>{group}</p>
        <p style={{ ...Serif, color: IVORY, fontSize: "clamp(1.1rem, 1.8vw, 1.35rem)" }}>{names}</p>
      </div>
    ))}
  </div>
);
